const info = {
  ZH: { //中文翻译

    statusTitle: " \u72B6\u6001",
    sendTable: " >> \u5DF2\u53D1\u9001\u7684\u6750\u6599\u6570\u636E\u8868",
    title: " \u5DF2\u53D1\u9001\u7684\u6750\u6599\u6570\u636E\u8868\u72B6\u6001",
    date: " \u65E5\u671F\: ",
    sendOrAccept: " \u53D1\u9001\u7684/\u63D0\u4EA4\u7684",
    dateTime: " (\u5E74(4\u4F4D)-\u6708(2\u4F4D)-\u65E5(2\u4F4D))",
    status: " \u72B6\u6001",
    status_N: " \u5C1A\u672A\u6D4F\u89C8",
    status_S: " \u5DF2\u6D4F\u89C8",
    status_A: " \u5DF2\u6279\u51C6",
    status_R: " \u5DF2\u62D2\u7EDD",
    status_M: " \u7F16\u8F91\u4E2D",
    status_C: " \u88AB\u53D1\u9001\u4EBA\u53D6\u6D88",
    status_D: "\u5DF2\u88AB\u4E0B\u8F7D",
    doNot: " \u672A\u6279\u51C6\u7684\u6750\u6599\u6570\u636E\u8868",
    name: " \u540D\u79F0\:",
    language: " \u8BED\u8A00\u9009\u62E9\:",
    language_C: " \u4E2D\u6587",
    language_E: " \u82F1\u6587",
    language_F: "  \u5916\u6587",
    code: " \u96F6\u90E8\u4EF6\u53F7\u3001\u534A\u6210\u54C1\u4EF6\u53F7\u3001\u6750\u6599\u53F7\:",
    id: "  ID:",
    version: " \u7248\u672C\u53F7\:",
    versionAll: " \u6240\u6709\u7248\u672C",
    versionNow: " \u5F53\u524D\u7248\u672C",
    chose: " (\u8BF7\u9009\u62E9...)",
    choseAll: " \u5168\u90E8",
    org: " \u6307\u6D3E\u8868\u5355\u7684\u90E8\u95E8\:",
    comp: " \u63A5\u6536\u4F01\u4E1A\:",
    from: " \u4ECE\:",
    to: " \u5230\:",
    search: " \u67E5\u627E",
    output: " \u5BFC\u51FA",
    existOrg: "\u4E0D\u80FD\u9009\u62E9\u76F8\u540C\u7684\u63A5\u6536\u4F01\u4E1A",
    cancel: " \u53D6\u6D88",
    maintitle: " \u4E2D\u56FD\u6C7D\u8F66\u6750\u6599\u6570\u636E\u7CFB\u7EDF",
    check_dateType: " \u65E5\u671F\u8BF7\u6309YYYY-MM-DD\u7C7B\u578B\u8F93\u5165",
    check_dateFromTo: " \u5F00\u59CB\u65E5\u671F\u5FC5\u987B\u5C0F\u4E8E\u7ED3\u675F\u65E5\u671F",
    fnc_chkNumber: " \u8BF7\u8F93\u5165\u6570\u5B57",
    bad: " \u6CA1\u6709\u7B26\u5408\u6761\u4EF6\u7684\u6570\u636E",
    confirm: " \u9009\u62E9\u989D\u5916\u7684\u67E5\u8BE2\u6807\u51C6\u53EF\u4EE5\u52A0\u5FEB\u67E5\u627E.\n\n\u4ECD\u7EE7\u7EED\u5417?",
    yearday: " [\u5E74(4\u4F4D)-\u6708(2\u4F4D)-\u65E5(2\u4F4D)]",
    deleteorg: "\u8BF7\u9009\u62E9\u8981\u5220\u9664\u7684\u4F01\u4E1A\u540D\u79F0",
    supplynumber: "\u4F9B\u8D27\u7F16\u53F7",
  },
  EN: { //英文翻译
    statusTitle: "	Status",
    sendTable: "	>> Sent MDSs",
    title: "	  status of sent MDSs",
    date: "	Date:",
    sendOrAccept: "Sent/proposed",
    dateTime: "	(Year(four digits)-Month(two digits)-Day(two digits))",
    status: "	Status",
    existOrg: "It is not allowed to select one recipient twice",
    status_N: "	not yet browsed",
    status_S: "	Viewed",
    status_A: "	Accepted",
    status_R: "	Rejected",
    status_M: "Edit mode",
    status_C: "Canceled by sender",
    status_D: "Downloaded",
    doNot: "	Non-accepted MDSs",
    name: "	Article Name:",
    language: "	Select language:",
    language_C: "	Chinese",
    language_E: "	English",
    language_F: "	Foreign language",
    code: "	Part/Item No., Item- /Mat.-No., Material No.",
    id: "	ID:",
    version: "	Version:",
    versionAll: "	All versions",
    versionNow: "	Current version",
    chose: "	(Please select ...)",
    choseAll: "	All",
    org: "Receiving Department",
    comp: "	Recipient",
    from: "	From:",
    to: "	To:",
    search: "Search",
    output: "	Export",
    cancel: "	Cancel",
    maintitle: "	China Automotive Material Data System (CAMDS)",
    check_dateType: "	The date format YYYY-MM-DD is expected.",
    check_dateFromTo: "	The start date must be earlier than the end date",
    fnc_chkNumber: "	Please input numbers",
    bad: "	no suitable data",
    confirm: "The search can be accelerated by entering additional search criteria.Continue anyway ? ",
    yearday : "	[Year(four digits)-Month(two digits)-Day(two digits)]",
    deleteorg: "	Please select the enterprise name to be removed!",
    supplynumber: "Designated Comp./semi./mat. No.",
  }
}
export default info //需要暴露出去
